import { render } from "./emailMarketing.vue?vue&type=template&id=2d3edec4&scoped=true"
import script from "./emailMarketing.vue?vue&type=script&lang=js"
export * from "./emailMarketing.vue?vue&type=script&lang=js"

import "./emailMarketing.vue?vue&type=style&index=0&id=2d3edec4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3edec4"]])

export default __exports__